import type { RouteRecordRaw } from 'vue-router';

export const pricingRoutes = {
  name: 'pricing',
  path: 'pricing',
  component: () => import('./Pricing.vue'),
} satisfies RouteRecordRaw;
